import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EMAIL_SUBSCRIBER_FEATURE_KEY, EmailSearchState } from './email-search.reducer';

// Lookup the 'EmailSearch' feature state managed by NgRx
export const selectEmailSearchState = createFeatureSelector<EmailSearchState>(EMAIL_SUBSCRIBER_FEATURE_KEY);

export const selectEmailSearchResults = createSelector(
  selectEmailSearchState,
  (state: EmailSearchState) => state.searchResults
);

export const selectEmailSearchLoaded = createSelector(
  selectEmailSearchState,
  (state: EmailSearchState) => state.loaded
);
